<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="row">
              <!-- <div class="col-lg-3 col-md-3 dataListStatus">
                <ul>
                  <li><h4>TASK STATUS</h4></li>
                  <li class="cp" (click)="getAllTask()">ALL TASKS<span class="New">{{Total_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('NEW')">NEW <span class="New">{{NEW_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('ASSIGNED')">ASSIGNED <span class="Work-In-Progress">{{ASSIGNED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('REASSIGNED')">REASSIGNED <span class="Pending">{{REASSIGNED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('WORK_IN_PROGRESS')">WORK_IN_PROGRESS <span class="Completed">{{WORK_IN_PROGRESS_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('PENDING')">PENDING <span class="Deferred">{{PENDING_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('COMPLETED')">COMPLETED <span class="Deferred">{{COMPLETED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('DEFERRED')">DEFERRED <span class="Deferred">{{DEFERRED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('PARTIALLY_COMPLETED')">PARTIALLY_COMPLETED <span class="Deferred">{{PARTIALLY_COMPLETED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('FORCE_CLOSED')">FORCE_CLOSED <span class="Deferred">{{FORCE_CLOSED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('CLOSED')">CLOSED <span class="Deferred">{{CLOSED_tasksCount}}</span></li>
                </ul>
              </div> -->
              <div class="col-lg-12 col-md-12 dataList" style="margin:0;padding: 0;">
                <div class="dataList-header">
                  <div class="dataList-header-left">
                    <h4>UPDATE TASK</h4>
                  </div>
                  <div class="dataList-header-right">
                    <input type="text" placeholder="Filter here" (keyup)="taskFilterByWildSearch(search.value)" #search [(ngModel)]="searchFilter">
                    <!-- <button data-toggle="modal" (click)="clearForm()" data-target="#exampleModal">Add Task</button> -->
                    <button (click)="searchclear()">Reset</button>
  
                  </div>
                </div>
                <div class="dataList-content">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 20%;">Name</th>
                        <th style="width: 75%;">Description</th>
                        <th style="width: 10%;">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let task of tasks | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                      }">
                        <td>{{task.name}}</td>
                        <td>{{task.description}}</td>
                        <td>
                          <svg xmlns="http://www.w3.org/2000/svg" (click)="getSingleTask(task.taskId)" data-toggle="modal" data-target="#exampleModal"  width="18" height="18" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                          </svg>
                          <!-- <svg xmlns="http://www.w3.org/2000/svg" (click)="del(task.id)" data-toggle="modal" data-target="#deleteModal"    width="18" height="18" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                          </svg> -->
                          <!-- <svg xmlns="http://www.w3.org/2000/svg" (click)="getSingleTask(task.id)" data-toggle="modal" data-target="#exampleModalCenter"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                          </svg>  -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="pagination-block" *ngIf="tasks.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
                  <div *ngIf="tasks.length == 0">
                    <p class="text-center">No records found.</p>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
  
  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">UPDATE TASK
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body">
    
          <div [formGroup]="editForm">
            <div class="row">
              <div class="col-md-12 col-lg-12">
                  <div class="col-md-11 col-11" style="padding: 0">
                    <div class="form-group">
                      <label>Task Name</label>
                      <input formControlName="name" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-1 col-1 task-button">
                    <div class="form-group">
                      <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#example" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg>
                    </div>
                  </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea name="" formControlName="description" id="" style="height: 70px"  class="form-control" cols="30" rows="10"></textarea>
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Assign To</label>
                  <select class="form-control" formControlName="assignedTo">
                    <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group ">
                  <label>Tag Users</label>
                  <ng-multiselect-dropdown
                  [placeholder]="'tag users'" [ngModelOptions]="{standalone: true}"
                  [settings]="tagUsersdropdownSettings"
                  [data]="tagUsersdropdownList"
                  [(ngModel)]="tagUsersselectedItems"
                  class="form-control"
                  style="padding: 0;border: none"
                  (onSelect)="onItemSelect($event)"
                  (onSelectAll)="onSelectAll($event)"
                  >
                  </ng-multiselect-dropdown>
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Exp Start Date</label>
                  <input formControlName="taskExpStartDate" value="{{tasks.taskExpStartDate}}"   type="date" class="form-control">
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Exp End Date</label>
                  <input formControlName="taskExpEndDate" value="{{tasks.taskExpEndDate}}" type="date" class="form-control">
                </div>
              </div>
            </div>
  
            <div class="col-lg-12" hidden="true">
                <label class="image-upload-container btn btn-bwm">
                    <input #imageInput
                          type="file" id="add-image-btn"
                          accept="image/*" hidden="true"
                          (change)="onChange($event)">
                </label>
            </div>
  
            <div class=" media-content">
                <div class="mr-2 image-btn" (click)="addImageBtn()">
                  <span>+ Add Image</span>
                </div>
                <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;" *ngFor="let image of images" class="mr-2">
                    <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
                </div>
            </div>
            
            <!-- <div class="" style="margin: 0;padding: 0;" hidden="true">
              <label class="image-upload-container btn btn-bwm">
                  <input #imageInput
                        type="file" id="add-video-btn"
                        accept="video/*" hidden="true"/
                        (change)="onSelectFile($event)">
                </label>
            </div>
            <div class=" media-content">
              <div class="mr-2 image-btn" (click)="addVideoBtn()">
                <span>+ Add video</span>
              </div>
              <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                  <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
              </div>
            </div> -->
          
            <!-- <div class="" style="margin: 0;padding: 0;" hidden="true">
              <label class="image-upload-container btn btn-bwm">
                  <input #imageInput
                        type="file" id="add-audio-btn"
                        accept="audio/*" hidden="true"
                        (change)="onSelectFile($event)">
                </label>
            </div>
            <div class=" media-content">
              <div class="mr-2 image-btn" (click)="addAudioBtn()">
                <span>+ Add Audio</span>
              </div>
              <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                  <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
              </div>
            </div>
          
            <div *ngFor="let audio of audios" class="mr-2">
              <audio controls>
                <source src="{{audio}}" type="audio/mpeg">
              </audio>
            </div> -->
          </div>
    
     
        <div class="modal-footer">
          <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="updatetask()" class="btn btn-primary">update Task</button>
        </div>
      </div>
    </div>
    </div>
  </div>
  
  
  
  <div class="modal fade" id="example" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Tasks</h5>
        </div>
        <div class="modal-body">
          <div class="status-table">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 20%;">Task SlNo</th>
                  <th style="width: 20%;">Task Name</th>
                  <th style="width: 40%;">Description</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let task of taskMasters" (click)="autoFill(task.name,task.description)">
                  <td>{{task.seqNo}}</td>
                  <td>{{task.name}}</td>
                  <td>{{task.description}}</td>
                </tr>
              </tbody>
            </table>
          </div>
     
          <div class="modal-footer">
            <button type="button" id="closeModalButton1"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>